import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { FormattedMessage } from 'react-intl';
import { useSidebarStyles } from './styles';
import { MOVE_TIME_STEPS, MOVE_TIME_STEP_KEYS } from './constants';

const StepSidebar = ({ activeStep }) => {
  const classes = useSidebarStyles();

  return (
    <Box className={classes.sidebar}>
      {MOVE_TIME_STEPS.map((step, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        const isResultStepActive =
          isActive && step.key === MOVE_TIME_STEP_KEYS.RESULT;

        return (
          <Box key={step.key} className={classes.stepItem}>
            <Box
              className={classNames(classes.stepNumber, {
                [classes.activeStepNumber]: isActive,
                [classes.completedStepNumber]:
                  isCompleted || isResultStepActive,
                [classes.inactiveStepNumber]: !isActive && !isCompleted
              })}
            >
              {isCompleted || isResultStepActive ? (
                <CheckIcon className={classes.checkIcon} />
              ) : (
                index + 1
              )}
            </Box>
            <Typography
              variant="body1"
              className={classNames({
                [classes.activeStepLabel]: isActive,
                [classes.inactiveStepLabel]: !isActive && !isCompleted
              })}
            >
              <FormattedMessage id={step.labelId} />
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

StepSidebar.propTypes = {
  activeStep: PropTypes.number.isRequired
};

export default StepSidebar;
